export const checkPermission = (permissionList: any[], permissionId: any) => {
  return permissionList.includes(permissionId);
};

export const idsArray = (array: any[]) => {
  return array.map((item: any) => item.id);
};
